// axiosInstance.js
import axios from 'axios';
import { AuthToast, OfflineToast } from 'common/components/toast';
import { history } from 'routes';
import { userLogout } from 'store';
import { GET_USER_URL } from 'actions/get-user-detail';

let isRefreshing = false;
let refreshPromise = null;

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(undefined, async error => {
  const originalRequest = error.config;
  const { pathname } = window.location;

  // If refreshPromise is false, log out and reject the error
  if (refreshPromise === false) {
    // console.log('logout1');
    handleLogout(pathname);
    return Promise.reject(error);
  }

  // Handle 498 status (typically expired session)
  if (error?.response?.status === 498) {
    if (isRefreshing) {
      return refreshPromise;
    }

    isRefreshing = true;

    try {
      if (!refreshPromise) {
        refreshPromise = axios.post('/api/gateway/refresh', null, {
          withCredentials: true,
        });
      }

      await refreshPromise;

      isRefreshing = false;
      refreshPromise = null;

      return axiosInstance(originalRequest);
    } catch (refreshError) {
      AuthToast(refreshError);
      refreshPromise = null;
      isRefreshing = false;
      handleLogout(pathname);
      return Promise.reject(refreshError);
    }
  }
  // Handle 401/403 error for GET_USER_URL only
  else if (
    error?.response?.status === 401 ||
    error?.config?.url == GET_USER_URL
  ) {
    if (!pathname.includes('/login') && !pathname.includes('/access')) {
      handleLogout(pathname);
    }
    // console.log('logout3', error.response.data);
    return Promise.reject(error.response?.data);
  }
  // Handle 500 or other errors - don't automatically log out
  else if (error?.response?.status === 500) {
    // console.log('Server error 500');
    // You could show a custom toast or notification here, without logging the user out.
    return Promise.reject(error); // Return the error for further handling by the app
  }
  // Handle network errors
  else if (error.message === 'Network Error') {
    OfflineToast();
    return Promise.reject({}); // Return empty object to avoid errors in the app
  }

  return Promise.reject(error);
});

const handleLogout = fromPath => {
  // console.log('logout4');
  userLogout();
  document.cookie = 'access_token=; Max-Age=0; Path=/';
  document.cookie = 'refresh_token=; Max-Age=0; Path=/';

  const redirectPath = fromPath.includes('/login') ? '/' : fromPath;
  history.push({
    pathname: '/login',
    state: { from: redirectPath },
  });
};

export default axiosInstance;
